package one.healthium.today.ui.calories_counter

data class CaloriesCounterUiModel(
    val caloriesGoal: NutritionGoalUiModel,
    val fatGoal: NutritionGoalUiModel,
    val carbohydratesGoal: NutritionGoalUiModel,
    val fiberGoal: NutritionGoalUiModel,
    val proteinGoal: NutritionGoalUiModel,
)

data class NutritionGoalUiModel(
    val goal: Float,
    val amount: Float,
) {
    val progress = if (goal == 0f) 0f else amount / goal
}